import { useSelector } from 'react-redux'
import { ROLE_CLIENT_ADMIN } from '@hixme/role-policy'
import { selectors as authSelectors } from '@hixme/auth-ui'

import useGlobalFlag from 'hooks/useGlobalFlag'

import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import { usePermission } from 'enrollment-platform/rbac/usePermission'
import { US_RESTRICTED_DATA_ENFORCEMENT_FLAG_KEY } from 'enrollment-platform/rbac/us-restricted-data-enforcement-flag'

/**
 * Whether the current user may see the Company page, shared by
 * CompanyAccessGate and the sidebar's Company profile link so they agree.
 * Only enforced when the EPS global flag
 * `service.eps.us-restricted-data.enable-enforcement` is on. Client Admins pass
 * on role alone; every other role must also hold Manage on UsRestrictedData.
 * Fail-closed on an ability error.
 */
export default function useCompanyAccess() {
  const { isEnabled: isEnforced, isLoading: isFlagLoading } = useGlobalFlag(
    US_RESTRICTED_DATA_ENFORCEMENT_FLAG_KEY
  )
  const role = useSelector(authSelectors.getRole) as string
  const { allowed, isLoading, isError } = usePermission(
    RbacActions.Manage,
    RbacSubjects.UsRestrictedData
  )
  if (role === ROLE_CLIENT_ADMIN) return { hasAccess: true, isLoading: false }
  if (isFlagLoading) return { hasAccess: false, isLoading: true }
  if (!isEnforced) return { hasAccess: true, isLoading: false }
  if (isLoading) return { hasAccess: false, isLoading: true }
  return { hasAccess: !isError && allowed, isLoading: false }
}
